import { StrictMode, Suspense, useSyncExternalStore } from 'react'
import { createRoot } from 'react-dom/client'
import { matchRoute, NotFoundPage } from './lib/router'
import './styles/global.css'

/**
 * Entry SPA dashboard (T121).
 *
 * Routing minimal tanpa library: `useSyncExternalStore` pada `location.pathname`.
 * Rute besar di-`lazy()` supaya muat pertama ringan. Deep link bekerja karena
 * Cloudflare Pages memakai `not_found_handling: "single-page-application"`.
 */

function subscribe(cb: () => void) {
  window.addEventListener('popstate', cb)
  return () => window.removeEventListener('popstate', cb)
}

function getPathname() {
  return window.location.pathname
}

function App() {
  const pathname = useSyncExternalStore(subscribe, getPathname)
  const route = matchRoute(pathname)

  // Rute tidak dikenal → 404.
  if (route === null) {
    return (
      <Suspense fallback={<Loading />}>
        <NotFoundPage />
      </Suspense>
    )
  }

  const Component = route.component

  return (
    <Suspense fallback={<Loading />}>
      <Component />
    </Suspense>
  )
}

function Loading() {
  return (
    <div className="flex min-h-[200px] items-center justify-center">
      <p className="text-ink-muted">Memuat…</p>
    </div>
  )
}

const container = document.getElementById('root')
if (container === null) throw new Error('Elemen #root tidak ditemukan.')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
